import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var key = new PluginKey('focusPluginHandler');
export var createPlugin = function createPlugin() {
  return new SafePlugin({
    key: key,
    state: {
      // @ts-ignore - Workaround for help-center local consumption
      init: function init() {
        return {
          hasFocus: false
        };
      },
      // @ts-ignore - Workaround for help-center local consumption
      apply: function apply(tr, oldPluginState) {
        var meta = tr.getMeta(key);
        if (typeof meta === 'boolean') {
          if (meta !== oldPluginState.hasFocus) {
            return {
              hasFocus: meta
            };
          }
        }
        return oldPluginState;
      }
    },
    props: {
      // @ts-ignore - Workaround for help-center local consumption

      handleDOMEvents: {
        // @ts-ignore - Workaround for help-center local consumption

        focus: function focus(view) {
          var focusState = key.getState(view.state);
          if (!(focusState !== null && focusState !== void 0 && focusState.hasFocus)) {
            view.dispatch(view.state.tr.setMeta(key, true));
          }
          return false;
        },
        // @ts-ignore - Workaround for help-center local consumption

        blur: function blur(view) {
          var focusState = key.getState(view.state);
          if (focusState !== null && focusState !== void 0 && focusState.hasFocus) {
            view.dispatch(view.state.tr.setMeta(key, false));
          }
          return false;
        }
      }
    }
  });
};